export default function Footer() {
  return (
    <footer className="bg-[#0A1A2F] text-gray-400 text-center py-6">
      © 2025 CodevianX | All Rights Reserved
    </footer>
  );
}
